(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    const productJSON = section.querySelector(".productV2JSON");
    const variantJSON = section.querySelector(".productV2VariantJSON");
    if (!productJSON || !variantJSON) {
        console.warn("Product section missing .productV2JSON or .productV2VariantJSON.");
        return;
    }

    // get product data
    const product = JSON.parse(productJSON.textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(variantJSON.textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    // initialize all swipers
    section.querySelectorAll(".productVisualSwiperGroupItem").forEach(el => {
        const swiperRoot = el.querySelector(".productVisualSwiper");
        if (!swiperRoot) {
            return;
        }
        const variantSwiper = new Swiper(swiperRoot, {
            slidesPerView: 1.2,
            spaceBetween: 0,
            autoHeight: true,
            breakpoints: {
                501: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            },
            on: {
                slideChange: function () {
                    if (!el.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }
                    // update the thumbnail active class
                    el.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
                    const thumbAtIndex = el.querySelectorAll(".productVisualThumbsSlide")[this.realIndex];
                    thumbAtIndex?.classList.add("active");
                }
            }
        });

        // change slide on thumbnail click
        el.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
            element.addEventListener("click", function () {
                // change slide
                const idx = Number(this.dataset.index);
                if (!Number.isFinite(idx)) {
                    return;
                }
                variantSwiper.slideTo(idx - 1);
            });
        });
    })

    /*****************
     Learn More Popup
     ******************/

    const learnBtn = section.querySelector('.productV2SellingOptionBulletsItemLearn');
    const learnMoreDialog = section.querySelector('.productV2SellingOptionBulletsItemLearnDialog');
    if (learnBtn && learnMoreDialog) {
        const body = document.body;
        learnBtn.addEventListener('click', () => {
            body.classList.add('noScroll');
            learnMoreDialog.showModal();
        })
        learnMoreDialog.addEventListener('close', () => body.classList.remove('noScroll'))
        learnMoreDialog.addEventListener('click', function (e) {
            if (e.target === this) this.close();
        })
        section.querySelectorAll('.productV2SellingOptionBulletsItemLearnClose').forEach(el => {
            el.addEventListener("click", () => learnMoreDialog.close());
        })
    }

    /*****************
     Nutritional Label
     ******************/

    const optionsItemButton = section.querySelector('.productV2OptionsItemButton');
    const imageDialog = section.querySelector('.productV2OptionsItemButtonDialog');
    const labelSwiperEl = imageDialog?.querySelector('.productV2OptionsItemButtonDialogImageSwiper');

    if (optionsItemButton && imageDialog && labelSwiperEl) {
        // dialog swiper
        const labelSwiper = new Swiper(labelSwiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            navigation: {
                prevEl: imageDialog.querySelector(".swiper-button-prev"),
                nextEl: imageDialog.querySelector(".swiper-button-next"),
            },
        })

        // closing events
        imageDialog.addEventListener("close", () => document.body.classList.remove('noScroll'))
        imageDialog.addEventListener("click", function (e) {
            if (e.target === this) this.close();
            if (e.target.classList.contains('productOptionsItemButtonDialogClose')) this.close();
        })
        imageDialog.querySelector('.productV2OptionsItemButtonDialogClose')?.addEventListener('click', () => {
            imageDialog.close();
        })

        // create an array for finding index
        const labelSlides = Array.from(imageDialog.querySelectorAll('.swiper-slide'));
        optionsItemButton.addEventListener('click', async function () {
            // check if a slide has variant id to match active and show that first
            if (imageDialog.querySelector(`.productV2OptionsItemButtonDialogImageSwiperSlide[data-id="${String(activeVariant.id)}"]`)) {
                // get index of slide and slide to it
                const index = labelSlides.findIndex(el => el.dataset.id === String(activeVariant.id));
                labelSwiper.slideTo(index);
            }
            // open dialog
            document.body.classList.add('noScroll');
            imageDialog.showModal();
        })

    }

    /**************
     Update Product
     ***************/

    // update section on input change to match variant
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", async function () {

            // if this is an option, update the active variant
            if (this.classList.contains("productV2OptionsItemValuesLabelInput")) {

                // create array of selected option ids
                const optionIDs = [];
                section.querySelectorAll(".productV2OptionsItemValuesLabelInput:checked").forEach(element => {
                    optionIDs.push(element.dataset.id);
                })

                // fetch updated variant data
                const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${optionIDs.join(',')}`)
                    .then(response => response.json());

                // update active variant
                activeVariant = response.active_variant;
            }

            // if variant change, update the variant description
            if (this.dataset.description) {
                const descEl = this.closest(".productV2ItemGroup")?.querySelector('.productV2OptionsItemDescription');
                if (descEl) {
                    descEl.textContent = this.dataset.description;
                }
            }

            // update the closest label - flavor name ex.
            const label = this.closest('.productV2ItemGroup')?.querySelector('.productV2Label');
            if (label) {
                const span = label.querySelector('span');
                if (span) {
                    span.textContent = this.value;
                }
            }

            // variety can only be a family plan
            if (this.value === 'variety' || this.classList.contains('productV2GroupsItemInput')) {
                // if variety pack chosen, ensure the 2 quantity is chosen
                if (varietyChosen()) {
                    section.querySelector('.productV2GroupsItem:last-child .productV2GroupsItemInput')?.click();
                }
            }

            // update product
            updateProduct().catch((err) => console.error(err));
        });
    })

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV2GroupsItemInput:checked')?.value) || null;
    }

    function varietyChosen() {
        return section.querySelector('.productV2OptionsItemValuesLabelInput:checked')?.value === 'variety';
    }

    async function updateProduct() {

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            const atc = section.querySelector(".productV2Atc");
            const atcText = section.querySelector(".productV2AtcText");
            if (atc) {
                atc.disabled = true;
            }
            if (atcText) {
                atcText.textContent = "Not Available";
            }
            return;
        }

        /**************
         Variant Image
         ***************/

            // hide all other swipers and show relevant one
        const comparison = varietyChosen() ? "variety" : activeVariant.id.toString();
        section.querySelectorAll('.productVisualSwiperGroupItem')?.forEach(el => {
            el.dataset.id === comparison
                ? el.classList.add('active')
                : el.classList.remove('active');
        })

        /************
         Buy Box text
         *************/

        const activePlan = section.querySelector('.productV2GroupsItemInput:checked');
        if (activePlan) {
            // update percentage off
            const sellingTopPercent = section.querySelector('.productV2SellingTopTitlePercent');
            if (sellingTopPercent) {
                sellingTopPercent.textContent = `${activePlan.dataset.percent}%`
            }

            // update relevant text on main bullet
            const planContent = activePlan.dataset.text.split('%');
            const monthlyEl = section.querySelector('.productV2SellingPointsMainBodyColumnMonthly');
            const deliveredEl = section.querySelector('.productV2SellingPointsMainBodyColumnDelivered');
            const descriptionEl = section.querySelector('.productV2SellingPointsMainBodyColumnDescription');
            const servingsEl = section.querySelector('.productV2SellingPointsMainBodyColumnServings');
            const perEl = section.querySelector('.productV2SellingPointsMainBodyColumnPer');
            if (monthlyEl) {
                monthlyEl.textContent = planContent[0];
            }
            if (deliveredEl) {
                deliveredEl.innerHTML = planContent[1];
            }
            if (descriptionEl) {
                descriptionEl.innerHTML = planContent[2];
            }
            if (servingsEl) {
                servingsEl.textContent = planContent[3];
            }
            if (perEl) {
                perEl.textContent = planContent[4];
            }

            /*******
             Price
             *******/

            // sub and otp button price targets - update quantity
            quantity = activePlan.dataset.quantity;
            const subPriceEl = section.querySelector(".productV2AtcSubPrice");
            const otpPriceEl = section.querySelector(".productV2AtcOtpPrice");
            // check if kids selected, special pricing
            if (activePlan.value === "692313948525") {
                if (subPriceEl) {
                    subPriceEl.textContent = "$39.99 monthly";
                }
                if (otpPriceEl) {
                    otpPriceEl.textContent = "$49.99 monthly";
                }
                section.querySelectorAll(".productV2AtcNotice").forEach(el => el.textContent = "2 month supply");

                // overwrite price on family plan
            } else if (activePlan.value === "692313981293") {
                if (subPriceEl) {
                    subPriceEl.textContent = "$118.98 monthly";
                }
                if (otpPriceEl) {
                    otpPriceEl.textContent = `${price(activeVariant.price * parseInt(quantity))} monthly`;
                }
                section.querySelectorAll(".productV2AtcNotice").forEach(el => el.textContent = "1 month supply");
            } else {
                if (subPriceEl) {
                    subPriceEl.textContent = `${price((activeVariant.price - (activeVariant.price * parseInt(activePlan.dataset.percent) / 100)) * parseInt(quantity))} monthly`;
                }
                if (otpPriceEl) {
                    otpPriceEl.textContent = `${price(activeVariant.price * parseInt(quantity))} monthly`;
                }
                section.querySelectorAll(".productV2AtcNotice").forEach(el => el.textContent = "1 month supply");
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            const subText = section.querySelector(".productV2AtcSubText");
            const otpText = section.querySelector(".productV2AtcOtpText");
            if (subText) {
                subText.innerHTML = "Autoship & Save";
            }
            if (otpText) {
                otpText.innerHTML = "One-Time Purchase";
            }
        } else {
            section.querySelectorAll(".productV2Atc").forEach(btn => { btn.disabled = true; });
            section.querySelectorAll(".productV2AtcSubText,.productV2AtcOtpText").forEach(el => { el.textContent = "Sold Out"; });
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch((err) => console.error(err));

    /**************
     Product ATC
     ***************/

    section.querySelectorAll('.productV2Atc').forEach(button => {
        button.addEventListener("click", async function () {

            // add loading animation to both buttons
            this.classList.add("loading");

            // check if subscription
            const hasSubscription = this.classList.contains('productV2AtcSubscribe');
            // get subscription plan
            let subPlanId = currentSellingPlan();

            let formData = [];

            // clear cart
            await fetch("/cart/clear.js");

            // check for selling plan and gift
            gifts?.forEach(gift => {
                const giftId = parseInt(gift.id);
                if (!giftId) return;
                if (hasSubscription || !gift.sub) {
                    formData.push(
                        {
                            quantity: 1,
                            id: giftId,
                            // flag as gift for mini cart
                            properties: {
                                _gift: true
                            }
                        }
                    )
                }
            })

            if (varietyChosen()) {
                section.querySelectorAll('.productV2OptionsItemValuesLabelInput:not([value="variety"])').forEach(el => {
                    formData.push({
                        quantity: 1,
                        id: parseInt(el.dataset.variant),
                        selling_plan: hasSubscription ? subPlanId : null,
                        // flag the associated plan for mini cart
                        properties: {
                            _plan: subPlanId,
                            _variety: true
                        }
                    })
                })
            } else {
                formData.push({
                    quantity: quantity,
                    id: activeVariant.id,
                    selling_plan: hasSubscription ? subPlanId : null,
                    // flag the associated plan for mini cart
                    properties: {
                        _plan: subPlanId
                    }
                })
            }

            // add product
            await addProduct({items: formData});

            // remove loading animation
            this.classList.remove("loading");

            // open cart
            await openCart();
        });
    })

    /**************
     Product FAQs
     ***************/

    // add faq information opening
    if (section.querySelector('.productV2Faqs')) {
        const buttons = section.querySelectorAll('.productV2FaqsItemsButton');
        buttons?.forEach(button => {
            button.addEventListener('click', function () {
                buttons.forEach(el => {
                    el === this ? el.classList.toggle('active') : el.classList.remove('active');
                });
            })
        })
    }

}());
